<template>
  <div class="accounts-page">
    <div class="page-header">
      <h2>Chart of Accounts</h2>
      <div class="actions">
        <!-- <input
          type="text"
          v-model="searchQuery"
          placeholder="Search accounts..."
          class="search-box"
        /> -->
        <!-- <button class="btn btn-green" @click="addAccount">Add Account</button> -->
        <button class="btn btn-blue" @click="printAccounts">
          Print Accounts
        </button>
      </div>
    </div>

    <div class="accounts-table">
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Account Name</th>
            <th>Type</th>
            <th>Balance (Ksh.)</th>
            <th>.</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(account, index) in filteredAccounts" :key="account.id">
            <td>{{ index + 1 }}</td>
            <td>{{ account.account_name }}</td>
            <td>{{ account.account_type }}</td>
            <td>
              {{
                formatAmount(get_balance(account.account_id, account.balance))
              }}
            </td>
            <td>
              <a :href="findRoute(account.account_id)" class="mybutton">
                detail
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!filteredAccounts.length" class="no-results">
        No accounts found.
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "AccountsPage",
  data() {
    return {
      accounts: [],
      searchQuery: "",
      inventoryWorth: "",
      payables_total: "",
      total_expenses: "",
    };
  },
  computed: {
    filteredAccounts() {
      if (!this.searchQuery.trim()) return this.accounts;
      const query = this.searchQuery.toLowerCase();
      return this.accounts.filter((acc) =>
        acc.name.toLowerCase().includes(query)
      );
    },
  },
  methods: {
    get_balance(id, balance) {
      switch (id.toString()) {
        case "4":
          // return "expense_account_detail/" + id;
          return this.total_expenses;
        case "5":
          return this.inventoryWorth;
        case "6":
          return this.payables_total;
        default:
          return balance;
      }
    },
    findRoute(id) {
      switch (id.toString()) {
        case "4":
          // return "expense_account_detail/" + id;
          return "/finance/expenses_overview";
        case "5":
          return "inventory_account_detail/" + id;
        case "6":
          return "payable_account_detail/" + id;
        default:
          return "finance_account_detail/" + id;
      }
    },
    async fetchAccounts() {
      var req_body = {};
      const url = `get_all_company_accounts`;
      const res = await generalApiRequest(url, "GET", req_body, 1);

      // 'inventoryWorth' => $inventoryWorth,
      //           'payables_total'=>$payables_total,
      //           'total_expenses'=>$total_expenses,

      this.accounts = res.data;
      this.inventoryWorth = res.inventoryWorth;
      this.payables_total = res.payables_total;
      this.total_expenses = res.total_expenses;
    },
    formatAmount(amount) {
      return amount.toLocaleString(undefined, { minimumFractionDigits: 2 });
    },
    addAccount() {
      // Add your modal or form logic here
      alert("Add account form would appear.");
    },
    printAccounts() {
      window.print();
    },
  },
  mounted() {
    this.fetchAccounts();
  },
};
</script>

<style scoped>
.accounts-page {
  margin-top: 1em;
  padding: 1rem;
  border: 1px solid black;
  background-color: #ffffff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}
.mybutton {
  float: right;
  border: 1px solid #d4cece;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.search-box {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.btn {
  padding: 8px 16px;
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

.btn-green {
  background-color: #28a745;
}

.btn-green:hover {
  background-color: #218838;
}

.btn-blue {
  background-color: #0069d9;
}

.btn-blue:hover {
  background-color: #0053b3;
}

.accounts-table table {
  width: 100%;
  border-collapse: collapse;
}

.accounts-table th,
.accounts-table td {
  border: 1px solid #ddd;
  padding: 0.75rem;
  text-align: left;
}

.accounts-table th {
  background-color: #f8f9fa;
}

.no-results {
  padding: 1rem;
  text-align: center;
  color: #888;
}
</style>
